import { useTranslate } from "@refinedev/core";
import { Grid2 as Grid, Typography } from "@mui/material";

import { Form } from "@shared/components";

export function ModuleStep() {
  const translate = useTranslate();

  return (
    <Grid container spacing={5}>
      <Grid size={{ xs: 12 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <Typography style={{ fontSize: 18, color: "primary.main" }}>
              {translate("flux.sections.linking_modules")}
            </Typography>
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="promocode_module"
              label={translate("flux.fields.promocode_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="cpf_module"
              label={translate("flux.fields.cpf_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="physical_card_module"
              label={translate("flux.fields.physical_card_module")}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <Typography style={{ fontSize: 18, color: "primary.main" }}>
              {translate("flux.sections.benefits_modules")}
            </Typography>
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="local_module"
              label={translate("flux.fields.local_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="ecommerce_module"
              label={translate("flux.fields.ecommerce_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="bookstore_module"
              label={translate("flux.fields.bookstore_module")}
            />
          </Grid>
        </Grid>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }}>
            <Typography style={{ fontSize: 18, color: "primary.main" }}>
              {translate("flux.sections.feature_modules")}
            </Typography>
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="referral_module"
              label={translate("flux.fields.referral_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="econometer_module"
              label={translate("flux.fields.econometer_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="be_partner_module"
              label={translate("flux.fields.be_partner_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="plan_sale_module"
              label={translate("flux.fields.plan_sale_module")}
            />
          </Grid>

          <Grid size={{ xs: 6, lg: 4 }}>
            <Form.Switch
              name="digital_magazines_module"
              label={translate("flux.fields.digital_magazines_module")}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
